module.exports = __webpack_public_path__ + "img/full6-min.17f584d6.png";